import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function CheckoutRedirect() {
  const location = useLocation();
  const hasOpenedRef = useRef(false);

  // Extract everything after "checkout_url=" to preserve all query parameters
  const getFullCheckoutUrl = () => {
    const search = location.search;
    const key = 'checkout_url=';
    const index = search.indexOf(key);

    if (index === -1) return null;

    const rawUrl = search.substring(index + key.length);
    
    try {
      // Handles both percent-encoded and raw unencoded URLs
      return decodeURIComponent(rawUrl);
    } catch {
      return rawUrl;
    }
  };

  const checkoutUrl = getFullCheckoutUrl();

  useEffect(() => {
    if (checkoutUrl && !hasOpenedRef.current) {
      hasOpenedRef.current = true;
      window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
    }
  }, [checkoutUrl]);

  if (!checkoutUrl) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Invalid Checkout Link</h2>
        <p>No redirection URL was provided.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Opening Checkout...</h2>
      <p>If your payment page did not open automatically, click the button below:</p>
      <a
        href={checkoutUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          marginTop: '1rem',
          padding: '0.75rem 1.5rem',
          backgroundColor: '#0070f3',
          color: '#fff',
          borderRadius: '6px',
          textDecoration: 'none',
          fontWeight: 'bold',
        }}
      >
        Proceed to Payment
      </a>
    </div>
  );
}